import { useNavigate } from '@tanstack/react-router';
import { NavButtonProps } from '../../types/Generics/NavButtonProps';

export const NavForward = (props: NavButtonProps) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate({ to: props.to });
  };
  return (
    <>
      {props.disabled ? (
        <button
          id={'nav-forward'}
          className="place-self-center rounded-md bg-stone-500 px-4 py-2 text-xl text-white hover:bg-stone-700 disabled:border-stone-700 disabled:text-slate-100 disabled:shadow-none sm:px-8 sm:py-3"
          type={'button'}
          onClick={() => {
            props.disabled
              ? alert('Please complete and submit all fields before attempting to continue.')
              : handleNavigate();
          }}
        >
          Next
        </button>
      ) : (
        <button
          id={'nav-forward'}
          className="place-self-center rounded-md bg-sky-700 px-4 py-2 text-xl text-white hover:bg-sky-800 disabled:border-stone-700 disabled:bg-stone-500 disabled:text-slate-100 disabled:shadow-none sm:px-8 sm:py-3"
          type={'button'}
          onClick={() => {
            props.disabled
              ? alert('Please complete and submit all fields before attempting to continue.')
              : handleNavigate();
          }}
          disabled={props.disabled}
        >
          Next
        </button>
      )}
    </>
  );
};
